import { Component, OnDestroy, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { Subject } from 'rxjs'
import { takeUntil, switchMap, tap, first, finalize } from 'rxjs/operators'

import { ClientsService } from '@app/modules/admin/clients/clients.service'
import { Client } from '@shared/models/client.model'
import { AuthService } from '@app/modules/auth/auth.service'
import { User } from '@shared/models/user.model'

@Component({
  selector: 'lin-create-user',
  templateUrl: './create-user.component.html',
  standalone: false,
})
export class CreateUserComponent implements OnInit, OnDestroy {
  user: User
  client: Client
  isLoaded = false

  private readonly onDestroy$ = new Subject<void>()

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly clientsService: ClientsService,
    private readonly authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.getClient()
  }

  private getClient(): void {
    const { id } = this.route.snapshot.params

    this.authService.currentUser$
      .pipe(
        first(),
        tap((user) => (this.user = user)),
        switchMap(() => {
          const clientId = this.user.isClient() ? this.user.team.clientId : <number>id

          return this.clientsService.getClient(clientId)
        }),
        finalize(() => (this.isLoaded = true)),
        takeUntil(this.onDestroy$),
      )
      .subscribe((client) => (this.client = client))
  }

  navigateToList(): void {
    const redirectUrl = this.user.isClient() ? ['../'] : ['/admin/clients', this.client.id, 'users']

    void this.router.navigate(redirectUrl, { relativeTo: this.route })
  }

  ngOnDestroy(): void {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }
}
